export default __webpack_public_path__ + "moin-app-illus-no-content.b77cf062c830c5ae233f2840528e96ac.png";